import Interceptor from "./Interceptor";

export const createSftpUser = async (payload) => {
  try {
    const response = await Interceptor.post("/sftp/create", payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSiteSftpUsers = async (siteId) => {
  try {
    const response = await Interceptor.get(`/sftp/users/${siteId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSiteSftpUser = async (siteId, username) => {
  try {
    const response = await Interceptor.get(`/sftp/${siteId}/${username}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSftpUserInfo = async (username) => {
  try {
    const response = await Interceptor.get(`/sftp/${username}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteSftpUser = async (siteId, username) => {
  try {
    const response = await Interceptor.delete(`/sftp/${siteId}/${username}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const allSftpUsers = async () => {
  try {
    const response = await Interceptor.get("/sftp/users");
    return response.data;
  } catch (error) {
    throw error;
  }
};
